export default "__VITE_ASSET__80706a64__"